<template>
  <div class="carousel-box">
    <el-carousel
      trigger="click"
      :interval="2000"
      height="500px"
      arrow="never"
      indicator-position="none"
      ref="carousel"
      :autoplay="autoplay"
      @change="changeItem"
    >
      <el-carousel-item>
        <img
          src="@/assets/ds/bg1.jpg"
          alt=""
          style="
            width: 100%;
            height: 100%;
            background-size: cover;
            object-fit: contain;
          "
        />
        <div class="banner-info-box">
          <div class="btn-box">
            <div class="span-btn span-btn-hollow">
              <i class="el-icon-phone"></i>
              联系我们：13816064096
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <img
          src="@/assets/ds/bg2.jpg"
          alt=""
          style="width: 100%; height: 100%; background-size: cover"
        />
        <div class="banner-info-box">
          <div class="btn-box">
            <div class="span-btn span-btn-hollow">
              <i class="el-icon-phone"></i>
              联系我们：13816064096
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="carousel-nav-box">
      <div
        class="carousel-nav-item"
        :class="active == '0' ? 'active' : 'noActive'"
        @click="clickBtn('0')"
      >
        <div class="progress-box">
          <div class="progress-item"></div>
        </div>
        <p></p>
      </div>
      <div
        class="carousel-nav-item"
        :class="active == '1' ? 'active' : 'noActive'"
        @click="clickBtn('1')"
      >
        <div class="progress-box">
          <div class="progress-item"></div>
        </div>
        <p></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "video-carousel",
  data() {
    return {
      active: "0",
      btnListDis: ["1", "2", "3", "4"],
      percentage: 20,
      customColor: "#409eff",
      autoplay: true,
    };
  },
  methods: {
    clickBtn(e) {
      this.$refs.carousel.setActiveItem(e); // 将tab的下标指定为走马灯的下标
      this.autoplay = false;
      this.active = e; // tab切换的下标
    },
    changeItem(e) {
      this.active = e; // 将走马灯的 下标 指定为 tab 的下标
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
video {
  width: 100%;
  position: absolute;
  display: flex;
  top: 50%;
  z-index: -1;
}

.carousel-box {
  position: relative;

  .banner-info-box {
    text-align: left;
    color: #ffffff;
    width: 870px;
    position: absolute;
    left: 10px;
    top: 30px;

    h1 {
      font-size: 50px;
    }

    .btn-box {
      margin-top: 80px;

      .span-btn {
        display: inline-block;
        padding: 15px 50px;
        background-color: #fff;
        color: #269ee8;
        border-radius: 50px;
        font-size: 22px;
        margin-right: 50px;
        cursor: pointer;
        transition: all 0.3s;

        // &:hover {
        //   background-color: rgba(54, 129, 194, 1);
        //   color: #ffffff;
        // }

        &.span-btn-hollow {
          background-color: rgba(0, 0, 0, 0.393);
          border: 2px solid #fff;
          color: #ffffff;

          // &:hover {
          //   background-color: rgba(255, 255, 255, 0.1);
          // }

          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.carousel-nav-box {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  bottom: 0;
  z-index: 99;

  .carousel-nav-item {
    width: 200px;
    color: #549eff;
    cursor: pointer;
    margin: 0 100px;

    .progress-box {
      width: 10%;
      height: 3px;
      border-radius: 10px;
      color: #549eff;

      .progress-item {
        width: 100%;
        height: 100%;
        background-color: #000000ba;
      }
    }

    &.noActive {
      color: #ffffff;

      .progress-box {
        background-color: #ffffff;
        width: 100%;
        // animation: mymove 1s;
        // -webkit-animation: mymove 1s;
      }
    }

    &.noActive:hover {
      color: #ffffff;

      .progress-box {
        background-color: #ffffff;
        width: 100%;
        // animation: mymove 1s;
        // -webkit-animation: mymove 1s;
      }
    }

    &.active {
      color: #ffffff;

      .progress-box {
        background-color: #ffffff;
        width: 100%;

        .progress-item {
          width: 100%;
          // animation: linemove 8s;
          // -webkit-animation: linemove 8s;
        }
      }
    }

    p {
      text-align: left;
      font-size: 14px;
    }
  }
}

@keyframes linemove {
  0% {
    width: 0;
  }

  100% {
    width: 100%;
  }
}

@keyframes mymove {
  0% {
    //transform: translateX(0%);
    width: 0;
  }

  12% {
    //transform: translateX(-10.89%);
    width: 10.89%;
  }

  24% {
    //transform: translateX(-43.56%);
    width: 43.56%;
  }

  36% {
    //transform: translateX(-98.01%);
    width: 98.01%;
  }

  54% {
    //transform: translateX(-75.02%);
    width: 75.02%;
  }

  74% {
    //transform: translateX(-98.37%);
    width: 98.37%;
  }

  82% {
    //transform: translateX(-93.75%);
    width: 93.75%;
  }

  92% {
    //transform: translateX(-99.34%);
    width: 99.34%;
  }

  96% {
    //transform: translateX(-98.46%);
    width: 98.46%;
  }

  100% {
    //transform: translateX(-100%);
    width: 100%;
  }
}
</style>
